export default "__VITE_ASSET__DML8UPwZ__"